import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertIcon, ChevronDownIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function FAQSection() {
  const {
    t
  } = useLanguage();
  const faqs = t('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-brand-bg-light border-t border-gray-800" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <div className="flex items-center justify-center gap-4 mb-16" data-id="element-99">
            <AlertIcon className="w-10 h-10 text-brand-gold" data-id="element-100" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-101">
              {t('faq.title')}
            </h2>
          </div>

          <div className="space-y-4" data-id="element-102">
            {Array.isArray(faqs) && faqs.map((faq: any, index: number) => <div key={index} className="bg-brand-bg-dark rounded-xl border border-gray-800 overflow-hidden" data-id="element-103">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-104">
                    <span className="text-xl font-heading font-bold text-white pr-8" data-id="element-105">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-6 h-6 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-106" />
                  </button>

                  <AnimatePresence data-id="element-107">
                    {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-108">
                        <div className="p-6 pt-0 text-lg text-gray-400 border-t border-gray-800/50" data-id="element-109">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}